const API_BASE = 'https://api.martechlabs.in';
export default API_BASE;
